// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-field-divider{margin-top:var(--spacer);color:var(--v-gray-dark);font-size:14px;line-height:20px;letter-spacing:.25px;display:flex;align-items:center;text-align:center}.form-field-divider:after,.form-field-divider:before{content:\"\";flex:1;border-bottom:1px solid var(--v-gray-light)}.form-field-divider:not(:empty):before{margin-right:var(--spacer-xxs)}.form-field-divider:not(:empty):after{margin-left:var(--spacer-xxs)}", ""]);
// Exports
module.exports = exports;
